import React from "react";
import featuredTag from "./featured.gif";
import { Clock, Star } from "./icons";
import { BAND, MUTED, gutter, oneLine, picture } from "./look";

const closedMark = {
  position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center",
  background: "rgba(0, 0, 0, 0.45)", color: "#fff", fontSize: 11, fontWeight: 700, letterSpacing: 0.5,
};

const freeDelivery = {
  display: "inline-block", marginTop: 4, padding: "2px 6px", borderRadius: 4, background: "#E6F4EA",
  color: "#1B7A38", fontSize: 10, fontWeight: 600, letterSpacing: 0.4,
};

const Divider = () => <span style={{ borderLeft: "1px solid #C9C9C9", height: 12, margin: "0 10px" }} />;

function Facts({ restaurant }) {
  return (
    <div className="d-flex align-items-center" style={{ fontSize: 12, whiteSpace: "nowrap", overflow: "hidden" }}>
      <Star />
      <span style={{ marginLeft: 5 }}>{restaurant.rating == null ? "5.0" : Number(restaurant.rating).toFixed(1)}</span>
      <Divider />
      <Clock />
      <span style={{ marginLeft: 5 }}>{`${restaurant.time_to_cook} Mins`}</span>
      <Divider />
      <span>₹ <span style={{ fontWeight: 500 }}>{restaurant.expence_meter}</span></span>
    </div>
  );
}

export default function RestaurantCard({ restaurant }) {
  const closed = restaurant.is_open === false;
  const photo = restaurant.images && restaurant.images[0] && restaurant.images[0].image;
  return (
    <div style={{ position: "relative" }}>
      {restaurant.is_open && restaurant.is_featured && (
        <img src={featuredTag} alt="Featured" style={{ position: "absolute", right: 0, top: 10, width: 88, height: 24 }} />
      )}
      <div className="d-flex" style={{ ...gutter, marginTop: 12, marginBottom: 12 }}>
        <div style={{ position: "relative", width: 94, height: 76, flexShrink: 0, borderRadius: 5, overflow: "hidden", background: closed ? "#000" : "#F1F1F1" }}>
          {photo && (
            <img src={picture(photo)} alt={restaurant.name}
              style={{ width: "100%", height: "100%", objectFit: "cover", opacity: closed ? 0.5 : 1 }} />
          )}
          {closed && <span style={closedMark}>CLOSED</span>}
        </div>
        <div className="d-flex flex-column justify-content-between" style={{ flex: 1, minWidth: 0, marginLeft: 10 }}>
          <div>
            <div style={{ ...oneLine, width: "70%", fontSize: 13, fontWeight: 600 }}>{restaurant.name}</div>
            {restaurant.free_delivery === true && <span style={freeDelivery}>FREE DELIVERY</span>}
            <div style={{ ...oneLine, fontSize: 12, color: MUTED, marginTop: 5 }}>{restaurant.description}</div>
          </div>
          <div style={{ borderBottom: `1px solid ${BAND}`, marginTop: 4, marginBottom: 9 }} />
          <Facts restaurant={restaurant} />
        </div>
      </div>
    </div>
  );
}
